import { Component } from '@verndale/core';
import { debounce } from 'lodash';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      utilityLanguage: this.el._$('.monogram-footer__utility-language-item'),
      dropDown: this.el._$('.monogram-footer__utility-language-dropdown'),
      additionalLinks: this.el._$('.footer__additional-links'),
      copyRight: this.el._$('.monogram-footer__copyright'),
      copyRightInd: this.el._$('.monogram-footer__copyright--independent'),
      subLinks: this.el._$$('.monogram-footer__privacy-sublink-item')
    };
    this.classes = {
      utilityOpen: 'monogram-footer__utility-language-dropdown-open'
    }

    if (this.dom.subLinks.length == 0) {
      this.el.classList.add('monogram-footer__sky-active');
    }
  }

  addListeners() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
    if (this.dom.utilityLanguage != null) {
      this.dom.utilityLanguage._on('click', this.handleToggleUtilityNavDropdown.bind(this));
    }
    window.addEventListener('resize', debounce(this.additionalLinksPosition.bind(this), 300));
    this.additionalLinksPosition();
  }

  handleClickOutside(e) {
    if (this.dom.dropDown !== e.target && this.dom.utilityLanguage !== null && !this.dom.utilityLanguage.contains(e.target)) {
      this.dom.dropDown.classList.remove(this.classes.utilityOpen);
    }
  }


  handleToggleUtilityNavDropdown(e) {
    e.preventDefault();
    if (this.dom.dropDown.classList.contains(this.classes.utilityOpen)) {
      this.dom.dropDown.classList.remove(this.classes.utilityOpen);
      return;
    }
    this.dom.dropDown.classList.remove(this.classes.utilityOpen);
    this.dom.dropDown.classList.add(this.classes.utilityOpen);
  }

  additionalLinksPosition() {
    this.dom.additionalLinks.remove();
    if (!this.dom.copyRightInd.offsetHeight) {
      this.dom.copyRight.after(this.dom.additionalLinks);
    } else {
      this.dom.copyRightInd.after(this.dom.additionalLinks);
    }
  }
}

export default Module;
